module.exports = __webpack_public_path__ + "505d2fd4a9acc32cba0c56d7a96e6ed1.woff";